import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// Legacy API imports (for backward compatibility)
import {
  LOAD_API,
  SMS_API,
  googleApiKey,
  LOCATION_API,
  IBAS_API,
  SMS,
  NIAP,
  BROKER_API,
} from "../http-common";

// New service layer imports
import services from "./services/api";
import {
  ibasClient,
  brokerClient,
  locationClient,
  niapClient,
  smsClient,
} from "./services/api/client";
import {
  setupErrorInterceptor,
  setupAuthInterceptor,
} from "./services/interceptors/error.interceptor";

// import "sweetalert2/dist/sweetalert2.min.css";
import VueSweetalert2 from "vue-sweetalert2";

// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";

import "bootstrap/dist/css/bootstrap.min.css";
import Vuelidate from "vuelidate";
import VueTheMask from "vue-the-mask";

import "bootstrap/dist/js/bootstrap.min.js";
import "@/assets/css/style.scss";

import VeeValidate from "vee-validate";
import * as VueGoogleMaps from "vue2-google-maps";
import "bootstrap-icons/font/bootstrap-icons.css";

import VueLoading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Maintenance from "./views/Maintenance.vue";

// Maintenance mode control (should be from environment variable)
const maintenanceMode =
  process.env.VUE_APP_MAINTENANCE_MODE === "true" || false;

Vue.use(VueLoading);
Vue.use(VeeValidate);
Vue.use(VueSweetalert2);
Vue.use(VueTheMask, { masked: false });
Vue.config.productionTip = false;
Vue.use(Vuelidate);

// Setup error interceptors for new service layer
setupErrorInterceptor(ibasClient);
setupErrorInterceptor(brokerClient);
setupErrorInterceptor(locationClient);
setupErrorInterceptor(niapClient);

// Setup auth interceptor for authenticated requests
setupAuthInterceptor(smsClient, store);

// Legacy API injection (backward compatibility)
// TODO: Gradually migrate to new $services architecture
Vue.use({
  install(Vue) {
    Vue.prototype.$api = SMS_API;
    Vue.prototype.$api2 = LOAD_API;
    Vue.prototype.$location = LOCATION_API;
    Vue.prototype.$api3 = IBAS_API;
    Vue.prototype.$sms = SMS;
    Vue.prototype.$niap = NIAP;
    Vue.prototype.$broker = BROKER_API;
  },
});

// New service layer injection (recommended approach)
Vue.use({
  install(Vue) {
    // Inject organized services
    Vue.prototype.$services = services;

    // Inject individual services for convenience
    Vue.prototype.$ibasService = services.ibas;
    Vue.prototype.$brokerService = services.broker;
    Vue.prototype.$locationService = services.location;
    Vue.prototype.$niapService = services.niap;
    Vue.prototype.$smsService = services.sms;
  },
});

Vue.use(VueGoogleMaps, {
  load: {
    key: googleApiKey,
    // libraries: "places",
  },
});

// Legacy interceptor for backward compatibility
Vue.use({
  install(Vue) {
    Vue.prototype.$api.interceptors.request.use(
      (config) => {
        let token = store.getters.token;
        if (token) {
          const d = new Date();
          config.headers = Object.assign(
            {
              "wsc-timestamp": d,
            },
            config.headers
          );
        }
        return config;
      },
      (error) => {
        console.log(error);
        return Promise.reject(error);
      }
    );
  },
});

new Vue({
  router,
  store,
  // render: (h) => h(App),
  render: (h) => h(maintenanceMode ? Maintenance : App),
}).$mount("#app");
